import React from "react";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import { Link, useNavigate } from "react-router-dom";
import { successAlert } from "../../../utils/sweetAlert";
import { authService } from "../../../services/authService";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

const btnForgotStyle = {
    backgroundColor: "#d81f19"
};
const recaptchaStyle = {
    width: "100%",
    maxWidth: "300px",
};

const iframeStyle = {
    transform: "scale(0.8)",
    transformOrigin: "0 0",
    width: "125%",
    height: "auto",
};
const validationSchema = Yup.object({
    username: Yup.string()
        .required("Vui lòng nhập tên đăng nhập")
        .min(8, "Tên đăng nhập phải từ 8 đến 20 ký tự")
        .max(20, "Tên đăng nhập phải từ 8 đến 20 ký tự")
        .matches(/^[^\s]+$/, "Tên đăng nhập không được chứa khoảng trắng")
        .matches(/^[a-zA-Z0-9@.]+$/, "Tên đăng nhập không được chứa ký tự đặc biệt"),
    email: Yup.string()
        .required("Vui lòng nhập email")
        .email("Email không hợp lệ")
        .matches(/^[^\s]+$/, "Email nhập không được chứa khoảng trắng")
        .matches(/^[a-zA-Z0-9@.]+$/, "Email nhập không được chứa ký tự đặc biệt")
});
export const ForgotPassword = () => {
    const navigate = useNavigate();
    const [formForgot, setFormForgot] = React.useState(() => ({
        username: "",
        email: ""
    }));
    const [errors, setErrors] = React.useState({});
    const [error, setError] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [recaptchaToken, setRecaptchaToken] = React.useState("");
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormForgot(prev => ({
            ...prev,
            [name]: value
        }))
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (!recaptchaToken) {
            setError("Vui lòng xác minh reCAPTCHA");
            setLoading(false);
            return;
        }
        validationSchema.validate(formForgot, { abortEarly: false })
            .then(() => {
                return authService.forgotPassword({ ...formForgot, recaptchaToken });
            })
            .then(() => {
                successAlert(
                    "Thành công",
                    "Mật khẩu mới đã được gửi về mail của bạn. Vui lòng kiểm tra mail",
                    3000,
                    () => navigate("/login")
                );
            })
            .catch((err) => {
                if (err.inner) {
                    const newErrors = {};
                    err.inner.forEach((error) => {
                        newErrors[error.path] = error.message;
                    });
                    setErrors(newErrors);
                } else {
                    const errorMessage = err.response?.data?.message || err.message;
                    console.log(errorMessage);
                    setError("Tên đăng nhập hoặc email không chính xác");
                }
                setRecaptchaToken("");
                window.grecaptcha.reset();
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const handleReCAPTCHAChange = (token) => {
        setRecaptchaToken(token);
        if (!token) {
            setError("Vui lòng xác minh reCAPTCHA");
        }
    };

    const handleReCAPTCHAExpired = () => {
        setRecaptchaToken("");
        window.grecaptcha.reset();
    };

    return (
        <>
            <Container className="mt-5">
                <Row className="">
                    <div className="d-flex justify-content-center">
                        <Col lg={5} md={6} sm={12} className="p-5 bg-light rounded">
                            <div className="text-center mb-5">
                                <h1>Quên mật khẩu</h1>
                            </div>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group controlId="username" className="mb-4">
                                    <Form.Control
                                        type="text"
                                        name="username"
                                        placeholder="Tên đăng nhập"
                                        value={formForgot.username}
                                        onChange={handleChange}
                                        isInvalid={!!errors.username}
                                        className="form-control-md"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.username}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="email" className="mb-4">
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        placeholder="Email"
                                        value={formForgot.email}
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                        className="form-control-md"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.email}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <div style={recaptchaStyle}>
                                    <ReCAPTCHA
                                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                        onChange={handleReCAPTCHAChange}
                                        onExpired={handleReCAPTCHAExpired}
                                        style={iframeStyle}
                                    />
                                </div>
                                <Button
                                    type="submit"
                                    className="w-100 mb-3"
                                    variant="danger"
                                    size="md"
                                    style={btnForgotStyle}
                                >
                                    {loading
                                        ? "Đang xử lý..."
                                        : "Quên mật khẩu"}
                                </Button>
                                {error && <div className="text-danger text-center my-2">{error}</div>}
                                <div className="d-flex justify-content-between">
                                    <Link to={"/login"} className="text-muted">
                                        Đăng nhập
                                    </Link>
                                    <Link to={"/register"} className="text-muted">
                                        Đăng ký tại đây
                                    </Link>
                                </div>
                            </Form>
                        </Col>
                    </div>
                </Row>
            </Container>
        </>
    )
}